import React from 'react';
import PropTypes from 'prop-types';
import { VODCSSModules } from 'shared/utils/wix-connect';
import classnames from 'classnames';
import styles from './track.styl';


const getSlideClasses = spec => {

  let index;
  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  let centerOffset;
  let slickActive;
  let slickCenter;
  const slickCloned = (index < 0) || (index >= spec.slideCount);
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if ((index > spec.currentSlide - centerOffset - 1) && (index <= spec.currentSlide + centerOffset)) {
      slickActive = true;
    }
  } else {
    slickActive = (spec.currentSlide <= index) && (index < spec.currentSlide + spec.slidesToShow);
  }
  return classnames({
    'slick-slide': true,
    'slick-active': slickActive,
    'slick-center': slickCenter,
    'slick-cloned': slickCloned,
  });
};

const getSlideStyle = spec => {
  const style = {
    width: spec.slideWidth,
    flexShrink: 0,
  };

  return style;
};

const getKey = (child, fallbackKey) => (
  // key could be a zero
  child.key === null || _.isUndefined(child.key) ? fallbackKey : child.key
);

const renderSlides = spec => {
  const slides = [];
  const preCloneSlides = [];
  const postCloneSlides = [];

  React.Children.forEach(spec.children, (child, index) => {
    const childStyle = getSlideStyle(_.assign({}, spec, { index }));
    const slickClasses = getSlideClasses(_.assign({ index }, spec));

    let cssClasses;
    if (child.props.className) {
      cssClasses = classnames(slickClasses, child.props.className);
    } else {
      cssClasses = slickClasses;
    }

    slides.push(React.cloneElement(child, {
      key: `original${getKey(child, index)}`,
      'data-index': index,
      className: cssClasses,
      style: _.assign({}, child.props.style || {}, childStyle),
    }));
  });

  return preCloneSlides.concat(slides, postCloneSlides);
};


@VODCSSModules(styles)
export default class Track extends React.Component {

  static propTypes = {
    trackStyle: PropTypes.object,
    getRef: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    getRef: _.noop,
  };

  render() {
    const slides = renderSlides(this.props);
    const { trackStyle, getRef, className } = this.props;

    return (
      <div ref={getRef}
           styleName="slick-track"
           className={className}
           style={trackStyle}>
        {slides}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mobile/views/home/components/mobile-carousel/track.js